import { Component, OnInit,EventEmitter } from '@angular/core';
import { InterviewdetailService } from './interviewdetail.service';
import { Router} from '@angular/router';
import { Observable } from "rxjs";
import { GetdataService } from '../interviewrating/getdata.service';
import { AuthService } from '../auth/login/auth.service';
@Component({
  selector: 'app-interviewdetail',
  templateUrl: './interviewdetail.component.html',
  styleUrls: ['./interviewdetail.component.css']
})
export class InterviewdetailComponent implements OnInit {

  constructor( private service : InterviewdetailService, private _router: Router,private getservice :GetdataService, private authservice :AuthService) { }


  
//isUserLoggedIn=true;
   public selectid;

 resultlist: Array<any> = [];
 result: any = {};

  ngOnInit() {

       this.authservice.checkCredentials();

     this.service.getUserData().subscribe(
       (data: any) =>{
         console.log(data);
          this.resultlist = data
        console.log('In Component resultlist here '+ this.resultlist);
       });
    

 }



    onSelect(selectedItem: any) 
    {
        console.log("Selected item Id: "+selectedItem.id); // get the Id of the selected item here
           
              this.selectid=selectedItem.id;
               
         console.log("Selected  Id: "+this.selectid); 

                 this.service.fetchData_Byid(this.selectid)
                    .subscribe(
                  (data: any) =>{
           console.log(data);
            this.result = data
          console.log('In Component  detail by selected id here '+ this.result);
       });
           

       

          this.getservice.getselected_Id(this.selectid);
        
    }


 }







// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/interviewdetail/interviewdetail.component.ts